import React, { Component } from 'react';
import { Table } from "react-bootstrap";
import Switch from "react-switch";
import PropTypes from "prop-types";
import { connect } from "react-redux";

class PermissionsAdmin extends Component {
    static contextTypes = { api: PropTypes.object };

    componentDidMount() {
        this.context.api.permissions.get(0, 200, { assignable: true })
    }

    hasPermission($permission) {
        return this.props.person.user.permissionsArray.includes($permission);
    }

    onChange({ permissionId, isEnabled }) {

        const userPermissions = this.props.permissions.reduce((acc, perm) => {
            if (this.props.person.user.permissionsArray.includes(perm.name)) {
                acc.push(perm.id);
            }
            return acc;
        },
            []);
        if (isEnabled) {
            userPermissions.push(permissionId);
        } else {
            userPermissions.splice(userPermissions.indexOf(permissionId), 1);
        }

        this.context.api.people.edit(this.props.person.id, { user: { id: this.props.person.user.id, permissions: userPermissions } })
            .then(() => this.context.api.people.refresh(this.props.person.id, "loadingId", "currentPerson"));

    }

    render() {
        return (
            <div>
                <h4>Permisos</h4>
                <Table>
                    <tbody>
                        {this.props.permissions.map((permission) => (
                            <tr key={permission.id}>
                                <td>{permission.title}</td>
                                <td>
                                    <Switch
                                        onChange={(value) => this.onChange({
                                            permissionId: permission.id,
                                            isEnabled: value
                                        })}
                                        checked={!!this.hasPermission(permission.name)} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }
}

const mapStateToProps = ({ api: { permissions = [] } }) => {
    return { permissions }
};

export default connect(mapStateToProps)(PermissionsAdmin);





// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/PersonDetail/components/PermissionsAdmin.jsx